import React, { useContext } from 'react';
import emailjs from 'emailjs-com';
import MyHeader from "../components/header";



const Contact = () => {
    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('service_9hpy3up', 'template_bwgmdc6', e.target, 'user_ioJvznO5DcwTLynIwhzw2')
          .then((result) => {
              console.log(result.text);
              alert('Your message may have sent')
              
          }, (error) => {
              console.log(error.text);
              alert('message not sent because of the following error: '+error.text)
          });
      }
    return ( 
        <>
        <div className="contact">
<h1>Contact</h1>

    <form className="contact-form" onSubmit={sendEmail}>
      <input type="hidden" name="contact_number" />

      <input className="underlinedTextArea" type="text" name="from_name" placeholder="Name" />
      <br />
    
      <input className="underlinedTextArea" type="email" placeholder="Email" name="from_email" />

      <br />
      <br />

      <div>
      <label>Message</label>
      <br />
      <textarea className="messageTextArea" name="message" />
      </div>


   <br />
      <input className="sendBtn" type="submit" value="Send" />
    </form>
        </div>
        </>
    );
}
export default Contact;














// function sendMail(){
//     // var cdn ='https://smtpjs.com/v3/smtp.js';
//     'https://smtpjs.com/v3/smtp.js'.Email.send({
//         SecureToken : "dda63c75-1fe8-4d23-8b0f-bbb3f4628a8f",
//         To : 'dr.sharjeel.6@gmail.com',
//         From : "dr.sharjeel.6@gmail.com",
//         Subject : "This is the subject",
//         Body : "And this is the body"
//     }).then(
//       message => alert(message)
//     );
// }
// export default Contact;

//dda63c75-1fe8-4d23-8b0f-bbb3f4628a8f -smtpCrediential
